import React, { useState, useEffect  } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import ApiSubHeader from '../parts/ApiSubHeader'
import Alert from 'react-s-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DictVocabItem from './DictVocabItem'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import DictMagicEditor from './DictMagicEditor'
import GenerateDictionaryModal from './GenerateDictionaryModal'

// ApiDictManager
const ApiDictManager = (props) => {

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false)
  let [kanjiInput, setKanjiInput] = useState("")
  let [kanaInput, setKanaInput] = useState("")
  let [typeInput, setTypeInput] = useState("")
  let [deepSpeechTokens, setDeepSpeechTokens] = useState([]);
  let [apiIdSelected, setApiIdSelected] = useState("")
  let [vocabList, setVocabList] = useState([])
  let [skip, setSkip] = useState(0)
  let [totalVocabCount, setTotalVocabCount] = useState(0)
  let [searchText, setSearchText] = useState("")
  let [editMode, setEditMode] = useState("default")

  let [addDictModalOpen, setAddDictModalOpen] = useState(false)

  let [useAsDict, setUseAsDict] = useState(true)
  let [categoryText, setCategoryText] = useState("")
  let [colorText, setColorText] = useState("")

  // componentDidMount
  useEffect(() => {

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = () => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return
    }

    if (subscription_status !== "active") {
      navigate("/api_manager_top")
      return
    }

    _getDeepSpeechTokens()
    // _getSharableDictionaryList()
  }

  // get tokens
  let _getDeepSpeechTokens = async () => {


    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getDeepSpeechTokens({
        login_token: login_token,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }


      // name to display
      let _list1 = _results.list1
      for ( let i=0; i<_list1.length; i++ ) {
        let _item = _list1[i]
        let _api_key = _item.api_key
        let _memo = _item.memo
        // let _disp = _item.api_key.substr(0, 16)+"…"
        // if ( _item.memo ) {
        //   if (_item.memo.length < 17) {
        //     _disp = _item.memo
        //   } else {
        //     _disp = _item.memo.substr(0, 16)+"…"
        //   }

        // }
        _list1[i].disp_name = _api_key + "(" + _memo + ")"
      }

      setDeepSpeechTokens(_list1)

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }



  // vocab list
  let _getVocabList = async ({
    ai_api_id,
    skip2,
  }) => {

    setLoading(true)

    try {

      if (!ai_api_id) {
        throw Error("no api is selected")
      }

      // logout on server
      let _results = await MyAPI.getVocabList({
        login_token: login_token,
        ai_api_id: ai_api_id,
        skip: skip2,
        search_text: searchText,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      // console.log("_results.list1: ", _results)

      if ( _results.list1 ) {
        setVocabList(_results.list1)
      } else {
        setVocabList([])
      }

      if (_results.count1) {
        setTotalVocabCount(_results.count1)
      } else {
        setTotalVocabCount(0)
      }

    } catch (err) {
      console.log("err: ", err)
    }

    setLoading(false)
  }

  // handle kanjiInput change
  let _kanjiInputChanged = (e) => {
    setKanjiInput(e.target.value)
  }

  // handle kanaInput change
  let _kanaInputChanged = (e) => {
    setKanaInput(e.target.value)
  }

  // handle typeInput change
  let _typeInputChanged = (e) => {
    setTypeInput(e.target.value)
  }

  // add a word into dictionary
  let _addVocab2Dict = async () => {

    setLoading(true)

    try {

      if (!apiIdSelected) {
        throw Error("no api is selected")
      }

      if (!kanjiInput) {
        throw Error("kanji is not detected")
      }

      if (!kanaInput) {
        throw Error("kana is not detected")
      }

      // logout on server
      let _results = await MyAPI.addOneWord2Dict({
        login_token: login_token,
        kanji: kanjiInput,
        kana: kanaInput,
        type: typeInput,
        ai_api_id: apiIdSelected,
        category_text: categoryText,
        color_text: colorText,
        use_as_dict: useAsDict,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      Alert.success("追加しました", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      // get vocab list again
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: skip
      })

      setTypeInput("")
      setKanaInput("")
      setKanjiInput("")

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }

  // api selected changed
  let _apiIdSelectedChanged = (e) => {

    setApiIdSelected(e.target.value)

    _getVocabList({
      ai_api_id: e.target.value,
      skip2: skip,
    })
  }

  // delete vocab
  let _deleteVocab = async (vocab_item) => {

    setLoading(true)

    try {

      if (!vocab_item) {
        throw Error("no api is selected")
      }

      // logout on server
      let _results = await MyAPI.deleteOneWordFromDict({
        login_token: login_token,
        vocab_id: vocab_item._id,
        // ai_api_id: apiIdSelected,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      Alert.success("削除しました", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      // get vocab list again
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: skip,
      })

      setTypeInput("")
      setKanaInput("")
      setKanjiInput("")

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }


  // update updatedAt
  let _updateUpdatedAt = async (item) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.updateVocabUpdatedAt({
        login_token: login_token,
        vocab_id: item._id,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // get vocabs
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: 0,
      })

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }


  // toggle 同音異義語
  let _toggleDoOnIgigoExists = async (item) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.toggleDoOnIgigoExists({
        login_token: login_token,
        vocab_id: item._id,
        ai_api_id: apiIdSelected,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // get vocabs
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: skip,
      })

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }

  // _searchTextChanged
  let _searchTextChanged = (e) => {
    setSearchText(e.target.value)
  }

  // go next 100
  let _goNext = () => {

    let _skip = skip
    _skip = _skip + 100

    if (_skip > totalVocabCount) {
      _skip = totalVocabCount
    }

    setSkip(_skip)

    // get vocabs
    _getVocabList({
      ai_api_id: apiIdSelected,
      skip2: _skip,
    })
  }

  // go back
  let _goBack = () => {
    let _skip = skip
    _skip = _skip - 100
    if (_skip < 0) {
      _skip = 0
    }
    setSkip(_skip)

    // get vocabs
    _getVocabList({
      ai_api_id: apiIdSelected,
      skip2: _skip,
    })
  }

  // toggle edit mode
  let _toggleEditMode = () => {
    if ( editMode === "default" ) {
      setEditMode("interactive")
    } else {
      setEditMode("default")
    }
  }

  // show alert
  let _showAlert = (message, type) => {

    if (type === "info") {
      Alert.info(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    } else if (type === "success") {
      Alert.success(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    } else if (type === "error") {
      Alert.error(message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  // set loader
  let _setLoading = (arg) => {
    setLoading(arg)
  }

  // get vocabs again
  let _getVocabListAgain = (api_key_id) => {

    // get vocabs
    _getVocabList({
      ai_api_id: api_key_id,
      skip2: 0,
    })
  }


  // toggle 重要後
  let _toggleImportantWord = async (item, rank) => {

    setLoading(true)

    try {

      // console.log("_toggleImportantWord.rank: ", rank)

      // get evaluation masters
      const results_1 = await MyAPI.toggleImportantWord({
        login_token: login_token,
        vocab_id: item._id,
        ai_api_id: apiIdSelected,
        rank: rank,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // get vocabs
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: skip,
      })


    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }

  // show generate new dictionary key modal
  let _showGenerateNewDicionaryModal = () => {
    setAddDictModalOpen(true)
  }

  let _closeAddDictModal = () => {
    setAddDictModalOpen(false)
    _getSharableDictionaryList()
  }

  // _getSharableDictionaryList
  let _getSharableDictionaryList = async () => {

    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getSharableDictionaryList({
        login_token: login_token,
        include_public: false,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }


      // name to display
      let _list1 = _results.list1
      for ( let i=0; i<_list1.length; i++ ) {

        let _item = _list1[i]
        _list1[i]._id = "dict_"+_item._id
        _list1[i].disp_name = _item.dictionary_name
      }

      setDeepSpeechTokens(_list1)

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
    setLoading(false)
  }

  return (
    <div>

      <Header />

      <ApiSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
        minHeight: 300,
      }}>

        {/* api keys */}
        <Row style={{
          // backgroundColor: '#cccccc',
          marginTop: 10,
          marginBottom: 5,
        }}>

          <Col md="6" xs="12" style={{
            textAlign: 'left',
          }}>

            <span style={{
              marginRight: 6,
            }}>
              APIキー（または辞書キー）を選択してください
            </span>

            <FontAwesomeIcon
              onClick={_showGenerateNewDicionaryModal}
              icon="circle-plus"
              style={{
                cursor: 'pointer',
                marginLeft: 6,
            }}/>

          </Col>

          <Col md="6" xs="12" />
        </Row>


        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>

          <Col md="12" xs="12" style={{
            textAlign: 'left',
          }}>

            <span onClick={_getDeepSpeechTokens} style={{
              cursor: 'pointer',
              marginRight: 10,
            }}>
              APIキーに紐づいた辞書を検索
            </span>


            <span>
             |
            </span>


            <span onClick={_getSharableDictionaryList} style={{
              cursor: 'pointer',
              marginLeft: 10,
            }}>
              共有可能な辞書を検索
            </span>

          </Col>

        </Row>

        <Row style={{
          // backgroundColor: '#cccccc',
          marginTop: 5,
          marginBottom: 40,
        }}>

          <Col md="6" xs="12" style={{
            textAlign: 'left',
          }}>
            <Input onChange={_apiIdSelectedChanged}
              type="select"
              name="apiIdSelected"
              value={apiIdSelected}>

              <option
                key={"dummy_api_key_id"}
                value={""}>
                  選択してください
              </option>

              {deepSpeechTokens.map((item) => (
                <option
                  key={item._id}
                  value={item._id}>
                    {item.disp_name}
                </option>
              ))}
            </Input>
          </Col>
          <Col md="6" xs="12" style={{
            textAlign: 'right',
            fontSize: 18,
          }}>

              {/*
              <span onClick={_toggleEditMode} style={{
                color: editMode === "default" ? '#555555' : '#008CC8',
                cursor: 'pointer',
              }}>
                <FontAwesomeIcon
                  icon="magic"
                  style={{
                    marginRight: 5,
                }}/>
                <span style={{
                  marginLeft: 5,
                }}>
                  簡単登録エディタ
                </span>
              </span>*/}


          </Col>

        </Row>


        {/* vocab headers */}
        {/* default mode */}
        {editMode === "default" && apiIdSelected && (
          <div>

            {/* controller */}
            <Row style={{
              backgroundColor: '#ffffff',
              marginTop: 10,
              marginBottom: 10,
              // marginLeft: 0,
              // marginRight: 0,
            }}>
              <Col md="6" xs="12">

                {/* search bar */}
                <InputGroup>

                  <Input
                    name='search_text'
                    onChange={_searchTextChanged}
                    value={searchText}
                    placeholder='かな' />

                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <FontAwesomeIcon
                        onClick={() => _getVocabList({ ai_api_id: apiIdSelected, skip2: skip })}
                        icon="search"
                        style={{
                          cursor: 'pointer',
                      }}/>
                    </InputGroupText>
                  </InputGroupAddon>

                </InputGroup>

              </Col>

              <Col md="6" xs="12" style={{
                textAlign: 'right',
              }}>

                {skip !== 0 ? (
                  <FontAwesomeIcon
                    onClick={_goBack}
                    icon="arrow-left"
                    style={{
                      cursor: 'pointer',
                      marginRight: 10,
                  }}/>
                ) : (
                  <FontAwesomeIcon
                    icon="arrow-left"
                    style={{
                      color: '#cccccc',
                      marginRight: 10,
                  }}/>
                )}

                {skip+100 > totalVocabCount ? (
                  <FontAwesomeIcon
                    icon="arrow-right"
                    style={{
                      marginLeft: 10,
                      color: '#cccccc',
                  }}/>
                ) : (
                  <FontAwesomeIcon
                    onClick={_goNext}
                    icon="arrow-right"
                    style={{
                      marginLeft: 10,
                      cursor: 'pointer',
                  }}/>
                )}

              </Col>
            </Row>


            <Row style={{
              backgroundColor: '#555555',
              color: '#ffffff',
              marginTop: 10,
              marginBottom: 10,
              marginLeft: 0,
              marginRight: 0,
            }}>

              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                <span>
                  漢字
                </span>
              </Col>
              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                <span>
                  かな
                </span>
              </Col>
              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                <span>
                  辞書利用
                </span>
              </Col>
              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                <span>
                  カテゴリー
                </span>
              </Col>
              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                カラー
              </Col>
              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                
              </Col>

            </Row>

            {/* vocab add */}
            <Row style={{
              // backgroundColor: '#cccccc',
              marginTop: 10,
              marginBottom: 10,
            }}>

              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>

                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='kanjiInput'
                  onChange={_kanjiInputChanged}
                  value={kanjiInput} />

              </Col>
              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='kanaInput'
                  onChange={_kanaInputChanged}
                  value={kanaInput} />
              </Col>
              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                
                {/* use as dictionary word or not */}
                <FontAwesomeIcon
                  onClick={() => setUseAsDict(!useAsDict)}
                  icon={useAsDict === true ? 'toggle-on' : 'toggle-off'}
                  style={{
                    cursor: 'pointer',
                    marginLeft: 6,
                }}/>


                {/*<Input onChange={_typeInputChanged}
                  type="select"
                  name="typeInput"
                  value={typeInput}>
                  <option value=""> - </option>
                  <option value="人名">人名</option>
                  <option value="組織">組織</option>
                  </Input>*/}


              </Col>

              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>

                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='categoryText'
                  onChange={(e) => setCategoryText(e.target.value)}
                  value={categoryText} /> 
               
              </Col>


              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>

                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='colorText'
                  onChange={(e) => setColorText(e.target.value)}
                  value={colorText} /> 
               
              </Col>

              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                <Button onClick={_addVocab2Dict} color="primary">
                  追加
                </Button>
              </Col>

            </Row>


            {/* vocab list */}
            {vocabList.map((item, idx) => (
              <DictVocabItem
                idx={idx}
                key={item._id}
                item={item}
                updateUpdatedAt={_updateUpdatedAt}
                toggleImportantWord={_toggleImportantWord}
                toggleDoOnIgigoExists={_toggleDoOnIgigoExists}
                deleteVocab={_deleteVocab}/>
            ))}

          </div>
        )}

        {/* interactive mode */}
        {editMode === "interactive" && apiIdSelected && (
          <DictMagicEditor
            getVocabListAgain={_getVocabListAgain}
            login_token={login_token}
            deepSpeechTokens={deepSpeechTokens}
            vocabList={vocabList}
            apiIdSelected={apiIdSelected}
            setLoading={_setLoading}
            showAlert={_showAlert} />
        )}

      </Container>

      <br/>

      {/* footer */}
      <Footer />

      {/* add new dictionary modal */}
      <GenerateDictionaryModal
        copyFromApiKeyId=""
        copyFromApi={false}
        login_token={login_token}
        showAlert={_showAlert}
        setLoading={setLoading}
        closeModal={_closeAddDictModal}
        isOpen={addDictModalOpen} />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default ApiDictManager
